<template>
  <div>
    <div class="row">
      <div class="col-10">
        <RecutSummaryWidget :filter="filter" :gridHeight="250" />
      </div>
      <div class="col-2">
        <AnalyticsWidget title="Detailed Reports" subTitle="Click to access the detailed reports" :gridHeight="250">
          <div class="p-2">
            <AnalyticsReportLink href="/analytics/reports/production/recutvalue#tab-panel-list">Recut Report</AnalyticsReportLink>
          </div>
        </AnalyticsWidget>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <DashboardTabbedContentBox :gridHeight="600" large>
          <template v-slot:tablist>
            <Tab :first="true" tabid="tab-recut-value">
              <i class="tabbedbox-tab-icon fas fa-layer-group"></i>
              <div class="tabbedbox-tab-info">
                <div class="tabbedbox-tab-title">Value</div>
                <div class="tabbedbox-tab-subtitle">Recut Breakdown Chart</div>
              </div>
            </Tab>
            <Tab tabid="tab-recut-count">
              <i class="tabbedbox-tab-icon fas fa-tools"></i>
              <div class="tabbedbox-tab-info">
                <div class="tabbedbox-tab-title">Count</div>
                <div class="tabbedbox-tab-subtitle">Recut Breakdown Chart</div>
              </div>
            </Tab>
          </template>
          <template v-slot:tabcontent>
            <TabPage :first="true" tabid="tab-recut-value" class="tabpage-padding-2">
              <RecutChartWidget
                :type="RecutChartTypes.breakdownValue"
                :gridHeight="500"
                :embedded="true"
                :showList="true"
                :filter="filter"
                :dateRangeType="ChartDateRangeTypes.custom"
                :startDate="appliedRecutFilter.startDate"
                :endDate="appliedRecutFilter.endDate"
                :showDateFilter="true"
                @updateEditingStartDate="editingRecutFilter.startDate = $event"
                @updateEditingEndDate="editingRecutFilter.endDate = $event"
                @dateApplied="applyRecutFilter"
                @dateReset="resetRecutFilter"
              />
            </TabPage>
            <TabPage tabid="tab-recut-count" class="tabpage-padding-2">
              <RecutChartWidget
                :type="RecutChartTypes.breakdownCount"
                :gridHeight="500"
                :embedded="true"
                :showList="true"
                :filter="filter"
                :dateRangeType="ChartDateRangeTypes.custom"
                :startDate="appliedRecutFilter.startDate"
                :endDate="appliedRecutFilter.endDate"
                :showDateFilter="true"
                @updateEditingStartDate="editingRecutFilter.startDate = $event"
                @updateEditingEndDate="editingRecutFilter.endDate = $event"
                @dateApplied="applyRecutFilter"
                @dateReset="resetRecutFilter"
              />
            </TabPage>
          </template>
        </DashboardTabbedContentBox>
      </div>
    </div>

  </div>
</template>


<script>
import _ from 'lodash'
import moment from 'moment'

import DashboardTitle from '@/components/dashboard/dashboardTitle'
import DashboardContentBox from '@/components/dashboard/dashboardContentBox'
import DashboardTabbedContentBox from '@/components/dashboard/dashboardTabbedContentBox'
import AnalyticsDashboardHeader from '@/modules/intelligence/components/analyticsDashboardHeader'
import AnalyticsWidget from '@/modules/intelligence/components/analyticsWidget'
import AnalyticsReportLink from '@/modules/intelligence/components/analyticsReportLink'
import AnalyticsDashboardValue from '@/modules/intelligence/components/analyticsDashboardValue'

import RecutSummaryWidget from '@/modules/intelligence/dashboardWidgets/recutSummaryWidget'
import RecutChartWidget from '@/modules/intelligence/dashboardWidgets/recutChartWidget'

import ReportFilterPopover from '@/components/reporting/reportFilterPopover'
import ReportDateRangeSelect from '@/components/reporting/reportDateRangeSelect'

import { ChartDateRangeTypes } from '@/modules/intelligence/types'

export default {
  name: 'AnalyticsRecutDashboard',
  components: {
    DashboardTitle,
    DashboardContentBox,
    DashboardTabbedContentBox,
    AnalyticsDashboardHeader,
    AnalyticsWidget,
    AnalyticsReportLink,
    AnalyticsDashboardValue,
    RecutSummaryWidget,
    RecutChartWidget,
    ReportFilterPopover,
    ReportDateRangeSelect
  },
  props: {
    filter: Object
  },
  data() {
    return {
      defaultRecutFilter: {    
        startDate: moment().local().startOf('month').toDate().toISOString(),
        endDate: moment().local().endOf('month').toDate().toISOString()
      },
      editingRecutFilter: {},
      appliedRecutFilter: {}
    }
  },
  created() {
    this.ChartDateRangeTypes = ChartDateRangeTypes
    this.RecutChartTypes = RecutChartWidget.RecutChartTypes
  },
  mounted() {
    this.editingRecutFilter = _.clone(this.defaultRecutFilter)
    this.appliedRecutFilter = _.clone(this.defaultRecutFilter)
  },
  beforeDestroy() {
    
  },
  methods: {
    applyRecutFilter() {
      this.appliedRecutFilter = _.clone(this.editingRecutFilter)
    },
    resetRecutFilter() {
      this.editingRecutFilter = _.clone(this.defaultRecutFilter)
      this.appliedRecutFilter = _.clone(this.defaultRecutFilter)
    },
    
  }
  
}
</script>